<!-- top-menu start -->
<nav class="navbar navbar-expand-lg" id="top-menu">
  <div class="container-fluid menu">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#top-menu-bar" aria-controls="top-menu-bar" aria-expanded="false" aria-label="Toggle navigation" (click)="bodyFixed()">
      <span class="icon"><i class="flaticon-left-alignment" ></i></span>
    </button>
    <a class="navbar-brand" title="{{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/']">
      <img class="img-fluid" [defaultImage]="'./assets/images/placeholder.jpg'" [lazyLoad]="(data | async)?.restaurant_data?.logo" 
      alt="{{(data | async)?.restaurant_data?.logo_alt_text ? (data | async)?.restaurant_data?.logo_alt_text : (data | async)?.restaurant_data?.restaurant_name}}" #logo />
    </a>
    <div class="collapse navbar-collapse" id="top-menu-bar">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item d-block d-lg-none">
          <a class="nav-link" [routerLink]="['/']" title="Home" routerLinkActive="active">Home</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.about_page?.is_active">
          <a class="nav-link" [routerLink]="['/about-us']" title="About" routerLinkActive="active">About</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_data?.gift_voucher && (data | async)?.restaurant_content?.gift_voucher_page?.is_active">
          <a class="nav-link" [routerLink]="['/gift-voucher']" title="Gift Voucher" routerLinkActive="active">Gift Voucher</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.team_page?.is_active">
          <a class="nav-link" [routerLink]="['/our-team']" title="Team" routerLinkActive="active">Team</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.deals_page?.is_active">
          <a class="nav-link" [routerLink]="['/deals']" title="Special Offers" routerLinkActive="active">Special Offers</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.xmas_page?.is_active">
          <a class="nav-link" [routerLink]="['/christmas']" title="Christmas - {{(data | async)?.restaurant_data?.restaurant_name}}" routerLinkActive="active">Christmas</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.menu_page?.is_active">
          <a class="nav-link" [routerLink]="['/menu']" title="Menu" routerLinkActive="active">Menu</a>
        </li>
        <li class="nav-item d-block d-lg-none" *ngIf="(data | async)?.restaurant_content?.order_online_page?.is_active">
          <a class="nav-link" [routerLink]="['/order-online']" title="Order Online" routerLinkActive="active">Order Online</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.booking_page?.is_active">
          <a class="nav-link" [routerLink]="['/reservation']" title="Reservation" routerLinkActive="active">Reservation</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.review_page?.is_active">
          <a class="nav-link" [routerLink]="['/reviews']" title="Reviews" routerLinkActive="active">Reviews</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.gallery_page?.is_active">
          <a class="nav-link" [routerLink]="['/gallery']" title="Gallery" routerLinkActive="active">Gallery</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.awards_page?.is_active">
          <a class="nav-link" [routerLink]="['/awards']" title="Awards" routerLinkActive="active">Awards</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.event_page?.is_active">
          <a class="nav-link" [routerLink]="['/events']" title="Events" routerLinkActive="active">Events</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.blog_page?.is_active">
          <a class="nav-link" [routerLink]="['/blogs']" title="Blog" routerLinkActive="active">Blog</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.news_media_page?.is_active">
          <a class="nav-link" title="News & Media - {{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/news-media']" routerLinkActive="active">News & Media</a>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.contact_page?.is_active">
          <a class="nav-link" [routerLink]="['/contact-us']" title="Contact" routerLinkActive="active">Contact</a>
        </li>
        <li class="nav-item" *ngIf="(user | async)?.isLogged === false">
          <a class="nav-link" [routerLink]="['/sign-in']" title="Sign In" routerLinkActive="active">Sign In</a>
        </li>
        <li class="nav-item" *ngIf="(user | async)?.isLogged === true">
          <a class="nav-link" [routerLink]="['/my-account']" title="My Account" routerLinkActive="active">My Account</a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto d-none d-lg-block">
        <li class="nav-item" *ngIf="(data | async)?.restaurant_data?.is_ordering && (data | async)?.restaurant_content?.order_online_page?.is_active">
          <a class="btn btn-lg orderBtn" [routerLink]="['/order-online']" title="Take-away" routerLinkActive="active">Take-away</a>
        </li>
      </ul>
      <ul class="navbar-nav d-block d-lg-none info-menu">
        <li class="nav-item">
          <span class="icon start"><i class="flaticon-phone" ></i></span>
          <p class="contacts">
            <ng-container *ngFor="let item of (data | async)?.restaurant_data?.business_tel | split; index as i;">
              <a class="nav-link py-0" title="{{item.trim()}}" href="tel:{{item.trim()}}">{{item.trim()}}</a>
            </ng-container>
          </p>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_data?.email && (data | async)?.restaurant_data?.email !==''">
          <span class="nav-link"><span class="icon"><i class="flaticon-envelope" ></i></span> {{(data | async)?.restaurant_data?.email}}</span>
        </li>
        <li class="nav-item" *ngIf="(data | async)?.restaurant_data?.domain !==''">
          <a class="nav-link" href="{{(data | async)?.restaurant_data?.domain}}" title="{{(data | async)?.restaurant_data?.domain}}">
            <span class="icon"><i class="flaticon-worldwide-1" ></i></span> {{(data | async)?.restaurant_data?.domain}}
          </a>
        </li>
      </ul>
      <p class="social-btns d-block d-lg-none mt-3">
        <a *ngFor="let item of (data | async)?.restaurant_data?.social_media" href="{{item?.link}}" title="{{item.media_name}}" target="_blank" class="btn {{item.media_name}}">
          <span class="ico"><i class="flaticon-{{item.media_name}}" ></i></span>
        </a>
      </p>
      <button type="button" class="btn d-block d-lg-none close-btn" data-toggle="collapse" data-target="#top-menu-bar" aria-controls="top-menu-bar" (click)="bodyFixed()">
        <span class="icon"><i class="flaticon-unchecked" ></i></span>
      </button>
    </div>
    <div class="overlay"></div>
  </div>
</nav>
<!-- top-menu end -->
